// 处理大板尺寸变化的操作
export const getPlankSizeOpration = (
  plank: any,
  newWidth: number,
  newHeight: number
) => {
  return {
    key: '修改大板尺寸',
    dataArr: [
      {
        type: 'form',
        current: {
          plankWidth: newWidth,
          plankHeight: newHeight,
        }, // 当前表单数据
        ori: {
          plankWidth: plank.plankWidth,
          plankHeight: plank.plankHeight,
        }, // 原始表单数据
        compareMsg: [
          {
            title: `大板序号: ${plank.canvasIndex}`,
            // `${this.activePlank.partName}-大板序号：${bigpart.canvasIndex}`
            keys: ['plankWidth', 'plankHeight'],
          },
        ], // 要比较的内容
        formTextObj: {
          plankWidth: '大板宽度',
          plankHeight: '大板长度',
        }, // key对应的意思
        formValueObj: {}, // value对应的意思
      },
    ],
  }
}
